<template>
  <div>
    <template v-if="currcomponent">
      <component v-bind:is="currcomponent" :metadata='metadata' :dbfield='dbfield' :value="value"
        v-model="invalue" v-on:input="$emit('input', invalue)" :isEdit="isEdit" :isSearch="isSearch"
        v-on:updatex="updatex"></component>
    </template>
    <b-row class="my-1">
      <template v-if="!currcomponent && dbfield!=='null' && !(!isEdit && metadata.edit_only)">
        <b-col sm="2"><label :for="dbfield+'_input'">{{metadata.label}}:</label></b-col>
        <b-col sm="10">
          <template v-if="input_type!=='select'">
            <b-form-input :lang="input_type=='number'?'en':'es'" :id="dbfield+'_input'" size="sm" :type="input_type"
                          :placeholder="read_only?'':metadata.label"
                          :value="value" v-on:input="emit_input($event)"
                          :plaintext="read_only" step="0.01"></b-form-input>
          </template>
          <template v-else-if="input_type==='select'">
            <b-form-select :id="dbfield+'_input'" size="sm" :value="value" v-on:input="$emit('input', $event)" >
              <template slot="first">
                <option :value="null">-- Seleccione una opcion --</option>
              </template>
              <template v-for="(choice, i) in metadata.choices">
                <optgroup v-if="choice.children" :key="'opt_'+i" :label="choice.display_name">
                  <option v-for="choicex in choice.children" :value="choicex.value" :key="'opt_'+choicex.value">{{choicex.display_name}}</option>
                </optgroup>
                <option v-else :value="choice.value" :key="'opt_'+choice.value">{{choice.display_name}}</option>
              </template>
            </b-form-select>
          </template>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import FormComponentBase from './FormComponentBase'

import FormComponentLandslide from './FormComponentLandslide'
import FormComponentGroup from './FormComponentGroup'
import FormComponentGPS from './FormComponentGPS'
import FormComponentMany from './FormComponentMany'
import FormComponentIFRM from './FormComponentIFRM'
import FormComponentFile from './FormComponentFile'
import FormComponentPrevInspection from './FormComponentPrevInspection'
import FormComponentRange from './FormComponentRange'
import FormComponentTextarea from './FormComponentTextarea'
import FormComponentInspectionSecurity from './FormComponentInspectionSecurity'
import FormComponentChoicexchoice from './FormComponentChoicexchoice'
import FormComponentPrevCatodico from './FormComponentPrevCatodico'
import FormComponentExists from './FormComponentExists'
import FormComponentChat from './FormComponentChat'
import FormComponentGroupSelect from './FormComponentGroupSelect'

export default {
  name: 'FormComponent',
  extends: FormComponentBase,
  components: {
    FormComponentLandslide,
    FormComponentGroup,
    FormComponentGPS,
    FormComponentMany,
    FormComponentIFRM,
    FormComponentFile,
    FormComponentPrevInspection,
    FormComponentRange,
    FormComponentTextarea,
    FormComponentInspectionSecurity,
    FormComponentChoicexchoice,
    FormComponentPrevCatodico,
    FormComponentExists,
    FormComponentChat,
    FormComponentGroupSelect
  },
  data () {
    return {
      invalue: null,
      currcomponent: null
    }
  },
  computed: {
    ...mapState({
      'user': 'user'
    }),
    read_only: function () {
      if (this.metadata.edit_roles) {
        if (!this.user) return true
        for (var i in this.metadata.edit_roles) {
          if ((this.user.roles.indexOf('_admin') !== -1) ||
            (this.user.roles.indexOf(this.metadata.edit_roles[i]) !== -1)) {
            return this.metadata.read_only
          }
        }
        return true
      } else {
        return this.metadata.read_only
      }
    }
  },
  mounted () {
    switch (this.metadata.type) {
      case 'ifrm': {
        this.currcomponent = 'FormComponentIFRM'
        break
      }
      case 'many': {
        this.currcomponent = 'FormComponentMany'
        break
      }
      case 'group': {
        this.currcomponent = 'FormComponentGroup'
        break
      }
      case 'landslide': {
        this.currcomponent = 'FormComponentLandslide'
        break
      }
      case 'gps': {
        this.currcomponent = 'FormComponentGPS'
        break
      }
      case 'file': {
        this.currcomponent = 'FormComponentFile'
        break
      }
      case 'prev_inspection': {
        this.currcomponent = 'FormComponentPrevInspection'
        break
      }
      case 'textarea': {
        this.currcomponent = 'FormComponentTextarea'
        break
      }
      case 'inspection_security': {
        this.currcomponent = 'FormComponentInspectionSecurity'
        break
      }
      case 'choicexchoice': {
        this.currcomponent = 'FormComponentChoicexchoice'
        break
      }
      case 'prev_catodico': {
        this.currcomponent = 'FormComponentPrevCatodico'
        break
      }
      case 'chat': {
        this.currcomponent = 'FormComponentChat'
        break
      }
      case 'groupselect': {
        this.currcomponent = 'FormComponentGroupSelect'
        break
      }
    }
    if (this.isSearch) {
      if (this.metadata.search.stype === 'range') {
        this.currcomponent = 'FormComponentRange'
      } else if (this.metadata.search.stype === 'exists') {
        this.currcomponent = 'FormComponentExists'
      }
    }
    if (this.value) {
      this.invalue = this.value
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'invalue', val)
      this.$emit('valuechange', val)
    }
  },
  methods: {
    emit_input (value) {
      if (this.input_type === 'number') { // aquí eliminó un parseInt()
        this.$emit('input', parseFloat(value))
      } else {
        this.$emit('input', value)
      }
    }
  }
}
</script>
